export default __webpack_public_path__ + "static/media/coin.23ad3396.png";